<script>
  import CartSale from '@/components/Ecommerce/Cart/CartSale'
  import CartTotal from '@/components/Ecommerce/Cart/CartTotal'
  import CartShipping from '@/components/Ecommerce/Cart/CartShipping'
  import CartTotalRow from '@/components/Ecommerce/Cart/CartTotalRow'
  import CartCoupon from '@/components/Ecommerce/Cart/CartCoupon'

  export default {
    components: {
      CartSale,
      CartTotal,
      CartTotalRow,
      CartShipping,
      CartCoupon
    },
    props: {
      formattedTotals: {
        type: Object,
        required: true
      },
      shipping: {
        type: Number,
        required: true
      },
      discounts: {
        type: Array,
        default: () => []
      },
      totalPriceWithDiscount: {
        type: Number,
        required: true
      },
      totalDiscount: {
        type: Number,
        required: true
      },
      coupon: {
        type: String,
        default: ''
      }
    }
  }
</script>

<template>
  <div class="w-full max-w-96 space-y-5">
    <CartTotalRow
      :amount="formattedTotals.exBtw"
      label="Totaal excl. btw"
    />
    <CartShipping :amount="shipping" />
    <CartTotalRow
      :amount="formattedTotals.btwAmount"
      label="BTW 9%"
    />
    <CartSale
      :amount="totalDiscount"
      :coupon="coupon"
    />
    <CartTotal
      :price="totalPriceWithDiscount + totalDiscount"
      :discount="totalPriceWithDiscount"
    />
    <CartCoupon class="block md:hidden" />
    <div class="md:pt-8">
      <e-button
        tag="nuxt-link"
        to="/afrekenen"
        type="primary"
        class="text-center w-full"
      >
        Ik ga bestellen
      </e-button>
    </div>
  </div>
</template>

<style>

</style>
